import React, { FC, ReactNode } from 'react'
import './tableToolbar.scss'

interface TableToolbarProps {
    children: ReactNode
}

export const TableToolbar: FC<TableToolbarProps> = ({ children }) => (
    <div className="table-toolbar">
        <div className="header-row">{children}</div>
    </div>
)
